var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSignout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 9.46496e-07C3.25223 9.46496e-07 0 3.25223 0 7.25C0 11.2478 3.25223 14.5 7.25 14.5C9.69687 14.5 11.8658 13.2844 13.1787 11.4224L12.1969 10.724C11.6396 11.5182 10.899 12.1664 10.0378 12.6134C9.17659 13.0604 8.22028 13.2931 7.25 13.2917C3.90594 13.2917 1.20833 10.5941 1.20833 7.25C1.20833 3.90594 3.90594 1.20833 7.25 1.20833C8.22024 1.2072 9.17645 1.43999 10.0376 1.88697C10.8987 2.33395 11.6394 2.98195 12.1969 3.77604L13.1787 3.07763C12.5101 2.1264 11.6223 1.35013 10.5904 0.814445C9.55843 0.27876 8.41269 -0.000593429 7.25 9.46496e-07ZM11.687 4.39894L10.8182 5.26773L12.1969 6.64583H4.83333V7.85417H12.1969L10.8182 9.23227L11.687 10.1011L14.1037 7.6844L14.5181 7.25L14.1031 6.81561L11.687 4.39894Z",
    fill: "#0D99FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSignout);
export default __webpack_public_path__ + "static/media/icon-signout.3dc6ece6.svg";
export { ForwardRef as ReactComponent };